import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 40 40"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12.1667 35V32.2223H18.6111V26.3889C17.1574 26.0833 15.8634 25.4606 14.7292 24.5208C13.5949 23.581 12.7963 22.4074 12.3333 21C10.2685 20.7685 8.5301 19.9097 7.11804 18.4236C5.70601 16.9375 5 15.1667 5 13.1111V11.3333C5 10.5648 5.27083 9.90971 5.8125 9.36804C6.35417 8.82638 7.00925 8.55554 7.77775 8.55554H11.7778V5H28.2222V8.55554H32.2223C32.9908 8.55554 33.6458 8.82638 34.1875 9.36804C34.7292 9.90971 35 10.5648 35 11.3333V13.1111C35 15.1667 34.294 16.9375 32.882 18.4236C31.4699 19.9097 29.7315 20.7685 27.6667 21C27.2037 22.4074 26.4051 23.581 25.2708 24.5208C24.1366 25.4606 22.8426 26.0833 21.3889 26.3889V32.2223H27.8333V35H12.1667ZM11.7778 18.0555V11.3333H7.77775V13.1111C7.77775 14.2963 8.15275 15.3403 8.90275 16.243C9.65278 17.1458 10.6111 17.75 11.7778 18.0555ZM28.2222 18.0555C29.3889 17.75 30.3472 17.1458 31.0973 16.243C31.8473 15.3403 32.2223 14.2963 32.2223 13.1111V11.3333H28.2222V18.0555Z",
                fill: (props === null || props === void 0 ? void 0 : props.color) || "#9F9DAE"
            }),
            "     "
        ]
    }));
};
export default Icon;
